import React from 'react';

import RangeSlider from '../../../components/form/range-slider/RangeSlider';

import 'rc-slider/assets/index.css';

const marks = {
  0.5: '0.5h',
  1: '1h',
  1.5: '1.5h',
  2: '2h',
  2.5: '2.5h',
  3: '3h',
  3.5: '3.5h',
  4: '4h'
};

interface Props {
  onChange?: (changeValue: number[]) => void;
  value?: number[];
}

const ProjectSettingsSlider: React.FC<Props> = ({ value, onChange }) => {
  return (
    <RangeSlider marks={marks} min={0.5} max={4} step={0.5} defaultValue={[0.5, 2]} firstMax={2} secondMin={2} value={value} onChange={onChange} />
  );
};

export default ProjectSettingsSlider;
